export default "__VITE_ASSET__fe3dcda3__"